import React from 'react';
import './Placeholder.css';

const Placeholder = ({ title }) => {
  return (
    <div className="placeholder-container">
      <h2 className="placeholder-title">{title}</h2>
      <div className="placeholder-message">В разработке</div>
    </div>
  );
};

export default Placeholder;
